import $ from 'jquery'

const body = $('html, body')
const docEl = document.documentElement

let breakable = true
let breakTimeout = null
let bound = false

function scrollClick(e)
{
	e.preventDefault()

	clearInterval(breakTimeout)
	breakable = false
	breakTimeout = setTimeout(function()
	{
		breakable = true
	}, 100)

	const scroll = $(this).data('scroll')
	let top = 0

	switch(scroll)
	{
		case 'top': top = 0; break
		case 'bottom': top = docEl.scrollHeight - docEl.clientHeight; break
		default: top = $(scroll).offset().top
	}

	body.animate({scrollTop: Math.min(top, docEl.scrollHeight - docEl.clientHeight)}, {duration: 500})
}

function bodyScroll(e)
{
	if(breakable && e.which > 0)
	{
		switch (e.type)
		{
			case 'mousedown':
			case 'mousewheel':
			case 'touchstart':
				body.stop()
				break
		}
	}
}

function bindScroll()
{
	if(!bound)
	{
		body.bind('scroll mousedown DOMMouseScroll mousewheel keyup touchstart', bodyScroll)
		bound = true
	}
}

export default function(context = document.body)
{
	const $context = $(context)

	$context.find('[data-scroll]').on('click', scrollClick)
	bindScroll()
}



// WEBPACK FOOTER //
// ./source/scripts/components/scroll.js